<template>
    <img
        v-bind:src="src"
        alt=""
        aria-hidden="true"
    >
</template>

<script lang="ts">
    import { computed, defineComponent } from 'vue';
    import { getFlagName } from '@/libraries/flagHelper';
    import { getSvgImage } from '@/libraries/helpers/imageHelper';

    export default defineComponent({
        props: {
            countryName: {
                type: String,
                required: true,
            },
        },
        setup(props) {
            const name = computed(() => getFlagName(props.countryName));

            const imageGlob = import.meta.glob('../assets/images/flags/*.svg', {
                eager: true,
            });

            const src = computed<string>(() => (name.value ? getSvgImage(imageGlob, name.value) : ''));

            return {
                src,
            };
        },
    });
</script>
